var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSomeFacebookCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 17.6065C35 7.88032 27.1673 0 17.5 0C7.83266 0 0 7.88032 0 17.6065C0 26.4097 6.35081 33.7221 14.748 35V22.7181H10.3024V17.6065H14.748V13.7728C14.748 9.3712 17.3589 6.88641 21.3105 6.88641C23.2863 6.88641 25.2621 7.24138 25.2621 7.24138V11.572H23.0746C20.8871 11.572 20.1815 12.9209 20.1815 14.3408V17.6065H25.0504L24.2742 22.7181H20.1815V35C28.5786 33.7221 35 26.4097 35 17.6065Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSomeFacebookCircle);
export default __webpack_public_path__ + "static/media/some-facebook-circle.6e5400614a2ec10fdf497b94e42d615d.svg";
export { ForwardRef as ReactComponent };